import React from "react";
import { useHistory } from "react-router";
import { AccessibleFocusOutline } from "./AccessibleFocusOutline";
import { ChevronRight } from "../common/IconsV2";

export const NextLink = ({
	delay,
	onDelayStart,
	to,
	onClick,
	textOverride,
	onClickAsync,
	variant,
	disabled,
}) => {
	const history = useHistory();

	const navOnClick = () => {
		if (onDelayStart) {
			onDelayStart();
		}
		setTimeout(() => {
			if (onClick) {
				if (onClickAsync === true) {
					const promise = onClick();
					if (promise) {
						promise.then(() => {
							history.push(to);
						});
					} else {
						history.push(to);
					}
				} else {
					onClick();
					history.push(to);
				}
			} else {
				history.push(to);
			}
		}, delay ?? 0);
	};

	const variantClasses = () => {
		switch (variant) {
			case "navigationButton":
				return "pointerCursor text-black navigation-next-button";
			case "navigationText":
				return "flex align-center items-center justify-end pointerCursor text-sm text-black text-right font-bold leading-snug";
			case "inactive":
				return "inactive-button";
			case "active":
				return "active-button";
			default:
				//Previous default style
				return `my-auto uppercase text-center text-white bg-app-charcoal px-3 py-2 rounded-lg w-full text-base block pointerCursor`;
		}
	};

	return (
		<AccessibleFocusOutline classes={"w-full"}>
			{variant === "navigationText" ? (
				<div
					onClick={navOnClick}
					disabled={disabled}
					className={`${variantClasses()}`}
				>
					{textOverride ? textOverride : "Next"}{" "}
					<ChevronRight className={"inline-block w-3.5 ml-2.5"} />
				</div>
			) : (
				<button
					onClick={navOnClick}
					className={`${variantClasses()}`}
					disabled={disabled}
				>
					{textOverride ? textOverride : "Next"}
				</button>
			)}
		</AccessibleFocusOutline>
	);
};
